/* Practi-Meds landing page (sections/mt-practi-meds.liquid).
   Behaviour ported from the standalone "Practi Meds Landing Page.html":
   reveal-on-scroll, hero rotator + tilt, stat counters, smooth FAQ accordion,
   step rail, quote bar, scroll progress, back-to-top, custom selects, quote
   form validation, mobile category carousel, mobile product accordion and
   the hero "star" buttons. The page's own top nav is replaced by the theme
   header, so the nav/burger/scroll-spy scripts are not carried over. */
(function () {
  if (window.__pmLpLoaded) return;
  window.__pmLpLoaded = true;
  function init(root) {
    if (!root || root.dataset.pmInit) return;
    root.dataset.pmInit = '1';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
    var RM = matchMedia('(prefers-reduced-motion:reduce)').matches;

    /* reveal */
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    $$('.rv').forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 6, 5) * 55) + 'ms';
      if (el.getBoundingClientRect().top < innerHeight) { el.classList.add('in'); return; }
      io.observe(el);
    });

    /* custom selects */
    $$('.sel').forEach(function (sel) {
      var btn = sel.querySelector('.sel-btn'), list = sel.querySelector('.sel-list'), val = sel.querySelector('.sel-val'), hid = sel.querySelector('input'), items = [].slice.call(list.children), idx = 0;
      function open(o) { sel.classList.toggle('is-open', o); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); if (o) { list.focus(); } }
      function pick(i) { idx = Math.max(0, Math.min(items.length - 1, i)); items.forEach(function (li, n) { li.classList.toggle('is-on', n === idx); li.setAttribute('aria-selected', n === idx ? 'true' : 'false'); }); val.textContent = items[idx].dataset.v; hid.value = items[idx].dataset.v; }
      btn.addEventListener('click', function (e) { e.stopPropagation(); $$('.sel.is-open').forEach(function (o) { if (o !== sel) o.classList.remove('is-open'); }); open(!sel.classList.contains('is-open')); });
      items.forEach(function (li, n) { li.addEventListener('click', function (e) { e.stopPropagation(); pick(n); open(false); btn.focus(); }); });
      list.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { open(false); btn.focus(); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); pick(idx + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); pick(idx - 1); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(false); btn.focus(); }
      });
      document.addEventListener('click', function () { open(false); });
    });

    /* quote form — inline field errors (capture phase, runs first) */
    var form = $('#quote-form'), msg = $('#form-msg');
    var rules = {
      'f-name': function (v) { return v ? '' : 'Add your name.'; },
      'f-school': function (v) { return v ? '' : 'Add your school or program.'; },
      'f-email': function (v) { return !v ? 'Add your work email.' : (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v) ? '' : 'That email looks incomplete — check the @ and domain.'); }
    };
    function check(el) {
      var m = rules[el.id](el.value.trim()); var id = el.id + '-err', e = document.getElementById(id);
      if (m) { if (!e) { e = document.createElement('small'); e.id = id; e.className = 'f-err'; el.insertAdjacentElement('afterend', e); } e.textContent = m; el.setAttribute('aria-invalid', 'true'); el.setAttribute('aria-describedby', id); el.classList.add('err'); }
      else { if (e) e.remove(); el.removeAttribute('aria-invalid'); el.removeAttribute('aria-describedby'); el.classList.remove('err'); }
      return !m;
    }
    if (form && $('#f-name')) {
      Object.keys(rules).forEach(function (id) {
        var el = document.getElementById(id); if (!el) return;
        el.addEventListener('blur', function () { if (el.value.trim() || el.dataset.touched) check(el); el.dataset.touched = '1'; });
        el.addEventListener('input', function () { if (el.getAttribute('aria-invalid')) check(el); });
      });
      form.addEventListener('submit', function () {
        Object.keys(rules).forEach(function (id) { var el = document.getElementById(id); if (el) check(el); });
        var b = form.querySelector('button[type=submit]');
        if (b && !form.querySelector('[aria-invalid]')) { b.setAttribute('aria-busy', 'true'); b.textContent = 'Sending…'; }
      }, true);
      /* block invalid submits; valid ones post to Shopify's contact endpoint */
      form.addEventListener('submit', function (e) {
        var bad = [];
        ['f-name', 'f-school', 'f-email'].forEach(function (id) { var el = document.getElementById(id); var ok = el.value.trim() && (id !== 'f-email' || /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(el.value)); el.classList.toggle('err', !ok); if (!ok) bad.push(el); });
        if (bad.length) { e.preventDefault(); msg.textContent = 'Please add your name, institution and a valid work email.'; bad[0].focus(); return; }
        try { sessionStorage.setItem('pm-quote-name', document.getElementById('f-name').value.trim().split(' ')[0]); } catch (err) {}
      });
    }
    /* after a successful post: personalise the thanks line like the original */
    var sentB = $('.sent b');
    if (sentB) {
      try { var nm = sessionStorage.getItem('pm-quote-name'); if (nm) { sentB.textContent = 'Thanks, ' + nm + ' — request received.'; sessionStorage.removeItem('pm-quote-name'); } } catch (err) {}
    }

    /* hero image rotator */
    (function () {
      var imgs = $$('.hs'); if (imgs.length < 2 || RM) return;
      var i = 0, t = null;
      function next() { imgs[i].classList.remove('is-on'); i = (i + 1) % imgs.length; imgs[i].classList.add('is-on'); }
      function start() { t = setInterval(next, 7000); }
      function stop() { if (t) clearInterval(t); }
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      start();
    })();

    /* hero tilt */
    var shot = $('.hero-shot'), hImg = shot && shot.querySelector('.hero-stack');
    if (shot && hImg && !RM && matchMedia('(hover:hover)').matches) {
      shot.addEventListener('pointermove', function (e) {
        var r = shot.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        shot.classList.add('tilt'); hImg.style.transform = 'perspective(900px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg) translateY(' + (y * -6).toFixed(1) + 'px)';
      });
      shot.addEventListener('pointerleave', function () { hImg.style.transform = ''; setTimeout(function () { shot.classList.remove('tilt'); }, 360); });
    }

    /* smooth accordion */
    $$('.faq-list details').forEach(function (d) {
      var s = d.querySelector('summary');
      s.addEventListener('click', function (e) {
        if (RM) return; e.preventDefault();
        if (d.classList.contains('closing') || d.classList.contains('opening')) return;
        if (!d.open) {
          d.open = true; d.classList.add('opening');
          requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('go'); }); });
          setTimeout(function () { d.classList.remove('opening', 'go'); }, 360);
        } else { d.classList.add('closing'); setTimeout(function () { d.classList.remove('closing'); d.open = false; }, 340); }
      });
    });

    /* step rail reveal */
    var sg = $('.step-grid');
    if (sg) { new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); o.unobserve(e.target); } }); }, { threshold: .25 }).observe(sg); }

    /* quote bar */
    var qbar = $('#qbar'), hero = $('.hero'), band = $('#quote');
    function qvis() { var y = window.scrollY + 0, past = y > (hero.getBoundingClientRect().bottom + window.scrollY) * .9, inBand = band.getBoundingClientRect().top < window.innerHeight * .85; qbar.classList.toggle('on', past && !inBand); }
    if (qbar && hero && band) {
      window.addEventListener('scroll', qvis, { passive: true }); window.addEventListener('resize', qvis); qvis();
      qbar.addEventListener('animationend', function () { qbar.classList.remove('pop'); });
    }

    /* scroll progress */
    var prog = $('#prog');
    function onScroll() { var d = document.documentElement, max = d.scrollHeight - innerHeight; prog.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, scrollY / max) : 0) + ')'; }
    if (prog) { addEventListener('scroll', onScroll, { passive: true }); onScroll(); }

    /* stat counters */
    (function () {
      var nums = $$('.num'); if (!nums.length) return;
      var nio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return; nio.unobserve(e.target);
          var el = e.target, to = +el.dataset.to; if (RM) { el.textContent = to; return; }
          var t0 = null, dur = 1400;
          function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur), e2 = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(to * e2); if (p < 1) requestAnimationFrame(step); }
          requestAnimationFrame(step);
        });
      }, { threshold: .6 });
      nums.forEach(function (n) { nio.observe(n); });
    })();

    /* back to top */
    var toTop = $('#to-top');
    function topVis() {
      toTop.classList.toggle('on', window.scrollY > window.innerHeight * .9);
      var r = toTop.getBoundingClientRect(), b = band.getBoundingClientRect(), mid = r.top + r.height / 2;
      toTop.classList.toggle('on-dark', mid > b.top && mid < b.bottom);
    }
    if (toTop && band) {
      toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: RM ? 'auto' : 'smooth' }); });
      window.addEventListener('scroll', topVis, { passive: true }); topVis();
    }

    /* section tag lines: sized so each runs ~1.5 lines (hero excluded) */
    (function () {
      var ps = $$('.sec .lede:not(.lede-split)'); if (!ps.length) return;
      function fit() {
        ps.forEach(function (p) {
          p.style.maxWidth = 'none'; var box = p.parentElement.clientWidth;
          var s = document.createElement('span'); s.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;font:' + getComputedStyle(p).font; s.textContent = p.textContent; document.body.appendChild(s); var w = s.getBoundingClientRect().width; s.remove();
          p.style.maxWidth = Math.min(box, Math.ceil(w / 1.5) + 8) + 'px';
        });
      }
      fit(); addEventListener('resize', fit); if (document.fonts) document.fonts.ready.then(fit);
    })();

    /* mobile: category carousel with arrows + dots */
    (function () {
      var t = $('#categories .cats'); if (!t || root.querySelector('.pmc-dots')) return;
      var cards = [].slice.call(t.querySelectorAll('.cat'));
      function go(i) { i = Math.max(0, Math.min(cards.length - 1, i)); t.scrollTo({ left: cards[i].offsetLeft - t.offsetLeft, behavior: 'smooth' }); }
      var sv = function (p) { return '<svg width=18 height=18 viewBox="0 0 24 24" fill=none stroke=currentColor stroke-width=1.6 stroke-linecap=round stroke-linejoin=round aria-hidden=true><path d="' + p + '"></path></svg>'; };
      var nv = document.createElement('div'); nv.className = 'pmc-nav';
      var pv = document.createElement('button'); pv.type = 'button'; pv.setAttribute('aria-label', 'Previous'); pv.innerHTML = sv('m15 18-6-6 6-6');
      var nx = document.createElement('button'); nx.type = 'button'; nx.setAttribute('aria-label', 'Next'); nx.innerHTML = sv('m9 18 6-6-6-6');
      nv.appendChild(pv); nv.appendChild(nx); t.parentNode.insertBefore(nv, t);
      var cur = 0;
      pv.addEventListener('click', function () { go(cur - 1); });
      nx.addEventListener('click', function () { go(cur + 1); });
      var d = document.createElement('div'); d.className = 'pmc-dots'; d.setAttribute('role', 'tablist'); d.setAttribute('aria-label', 'Category slides');
      cards.forEach(function (c, i) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (i + 1)); b.addEventListener('click', function () { go(i); }); d.appendChild(b); });
      t.parentNode.insertBefore(d, t.nextSibling);
      function upd() {
        var x = t.scrollLeft, best = 0, bd = 1e9;
        cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - t.offsetLeft - x); if (dd < bd) { bd = dd; best = i; } });
        if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) best = cards.length - 1;
        cur = best; pv.disabled = best === 0; nx.disabled = best === cards.length - 1;
        [].forEach.call(d.children, function (b, i) { b.classList.toggle('is-on', i === best); });
      }
      t.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); upd();
    })();

    /* mobile: products as an accordion */
    (function () {
      var g = $('#products .prods'); if (!g || root.querySelector('.pma')) return;
      var items = [].slice.call(g.querySelectorAll('.prod'));
      var ul = document.createElement('ul'); ul.className = 'pma'; var open = -1;
      function headerOffset() { var h = document.querySelector('.section-header'); return (h ? h.getBoundingClientRect().height : 64) + 12; }
      function set(i, ev) {
        var rows = ul.children;
        for (var j = 0; j < rows.length; j++) { var on = j === i; rows[j].classList.toggle('is-open', on); rows[j].querySelector('.pma-head').setAttribute('aria-expanded', on ? 'true' : 'false'); }
        open = i;
        if (i >= 0 && ev) {
          var li = rows[i];
          setTimeout(function () { var off = headerOffset(); var top = li.getBoundingClientRect().top; if (top < off || top > window.innerHeight * .55) window.scrollTo({ top: top + window.scrollY - off, behavior: 'smooth' }); }, 320);
        }
      }
      items.forEach(function (p, i) {
        var img = p.querySelector('.prod-shot img'), name = p.querySelector('b'), sim = p.querySelector('.sim'), meta = p.querySelector('.prod-meta'), btn = p.querySelector('.btn');
        var li = document.createElement('li'); li.className = 'pma-row';
        li.innerHTML = '<button type=button class=pma-head aria-expanded=false><span class=pma-ic></span><span class=pma-t></span><span class=pma-chev aria-hidden=true></span></button><div class=pma-panel role=region><div class=pma-in><div class=pma-ph></div><div class=pma-body><p></p><div class=pma-meta></div><button type=button class=pma-go></button></div></div></div>';
        if (img) { var a = img.cloneNode(); a.removeAttribute('loading'); li.querySelector('.pma-ic').appendChild(a); var b = img.cloneNode(); b.removeAttribute('loading'); li.querySelector('.pma-ph').appendChild(b); }
        li.querySelector('.pma-t').textContent = name ? name.textContent : '';
        li.querySelector('.pma-body p').textContent = sim ? sim.textContent : '';
        if (meta) li.querySelector('.pma-meta').innerHTML = meta.innerHTML;
        var go = li.querySelector('.pma-go'); go.textContent = btn ? btn.textContent : 'Add to quote';
        go.addEventListener('click', function () { if (btn) btn.click(); });
        li.querySelector('.pma-head').addEventListener('click', function (e) { set(open === i ? -1 : i, e); });
        ul.appendChild(li);
      });
      g.parentNode.insertBefore(ul, g); set(0, null);
    })();

    /* hero buttons: label + travelling "star" spans (styled on mobile) */
    var w = $('.hero .hero-cta');
    if (w) {
      w.querySelectorAll('.btn').forEach(function (a) {
        if (a.querySelector('.pmb-lbl')) return;
        var l = document.createElement('span'); l.className = 'pmb-lbl'; while (a.firstChild) l.appendChild(a.firstChild);
        var t = document.createElement('span'); t.className = 'pmb-st'; var b = document.createElement('span'); b.className = 'pmb-sb';
        a.appendChild(t); a.appendChild(b); a.appendChild(l);
      });
    }
  }

  /* The page is split into several mt-pm-* sections that each include this
     script, so run once for the whole page (ids like #quote and #products
     are page-unique). In the theme editor a re-rendered section is
     initialised on its own. */
  function boot() { if (document.querySelector('.pm-lp')) init(document.body); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('.pm-lp')) init(e.target); });
})();
